import { api } from './api';

export interface TimerResponse {
  activo: boolean;
  actividad_id: string | null;
  actividad_titulo: string | null;
  inicio: string | null;
  pausado: boolean;
  minutos_transcurridos: number;
}

export interface TiempoRegistroResponse {
  id: string;
  actividad_id: string;
  usuario_id: string;
  fecha: string;
  hora_inicio: string | null;
  hora_fin: string | null;
  minutos: number;
  descripcion: string | null;
  es_facturable: boolean;
  origen: 'TIMER' | 'MANUAL';
  created_at: string;
  actividad_titulo: string | null;
}

export interface TiempoRegistroCreate {
  actividad_id: string;
  fecha: string;
  minutos: number;
  descripcion?: string;
  es_facturable?: boolean;
}

export interface TiempoRegistroUpdate {
  minutos?: number;
  fecha?: string;
  descripcion?: string;
  es_facturable?: boolean;
  hora_inicio?: string;
  hora_fin?: string;
}

export interface ResumenTiempoResponse {
  fecha: string;
  total_minutos: number;
  registros: TiempoRegistroResponse[];
}

export const tiempoService = {
  // Timer
  getTimerActivo: () => api.get<TimerResponse>('/tiempo/timer'),

  iniciarTimer: (actividad_id: string) =>
    api.post<TimerResponse>('/tiempo/timer/iniciar', { actividad_id }),

  pausarTimer: () => api.post<TimerResponse>('/tiempo/timer/pausar'),

  reanudarTimer: () => api.post<TimerResponse>('/tiempo/timer/reanudar'),

  detenerTimer: () => api.post<TiempoRegistroResponse>('/tiempo/timer/detener'),

  // Registros manuales
  registrarManual: (data: TiempoRegistroCreate) =>
    api.post<TiempoRegistroResponse>('/tiempo/registros', data),

  listarRegistros: (params?: { actividad_id?: string; fecha_desde?: string; fecha_hasta?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.actividad_id) searchParams.set('actividad_id', params.actividad_id);
    if (params?.fecha_desde) searchParams.set('fecha_desde', params.fecha_desde);
    if (params?.fecha_hasta) searchParams.set('fecha_hasta', params.fecha_hasta);
    const query = searchParams.toString();
    return api.get<TiempoRegistroResponse[]>(`/tiempo/registros${query ? `?${query}` : ''}`);
  },

  actualizarRegistro: (id: string, data: TiempoRegistroUpdate) =>
    api.patch<TiempoRegistroResponse>(`/tiempo/registros/${id}`, data),

  eliminarRegistro: (id: string) => api.delete<void>(`/tiempo/registros/${id}`),

  // Resumenes
  resumenDia: (fecha?: string) => {
    const query = fecha ? `?fecha=${fecha}` : '';
    return api.get<ResumenTiempoResponse>(`/tiempo/resumen/dia${query}`);
  },

  resumenSemana: (fecha_inicio?: string) => {
    const query = fecha_inicio ? `?fecha_inicio=${fecha_inicio}` : '';
    return api.get<ResumenTiempoResponse[]>(`/tiempo/resumen/semana${query}`);
  },
};
